(() => {
  'use strict';
  const held = new Set(['44641620099357','44641507344669','44641507377437','44641507410205','49903010971933','49903011004701']);
  const sizes = '(min-width: 1440px) 660px, (min-width: 990px) calc((100vw - 100px) / 2), (min-width: 768px) 540px, calc(100vw - 66px)';
  function enabled(root) {
    const selected = root?.querySelector('[data-hh-pdp-variant-select]')?.value;
    return !!selected && !held.has(String(selected)) && !!root.ownerDocument.querySelector('[data-qa-theme="191362662685"]');
  }
  function resized(src, width) {
    try {
      const url = new URL(src, 'https://healthyhey.com');
      const own = url.hostname === 'healthyhey.com' && url.pathname.startsWith('/cdn/shop/files/');
      const cdn = url.hostname === 'cdn.shopify.com' && url.pathname.startsWith('/s/files/');
      if(url.protocol !== 'https:' || (!own && !cdn) || url.hash || ![120,240,360,540,720,1000].includes(width)) return src;
      url.searchParams.set('width', String(width));
      return url.href;
    } catch { return src; }
  }
  function apply(image, src, thumbnail) {
    const widths = thumbnail ? [120,240] : [360,540,720,1000];
    if(resized(src,widths[0]) !== src) {
      image.sizes = thumbnail ? '60px' : sizes;
      image.srcset = widths.map(w=>resized(src,w)+' '+w+'w').join(', ');
    }
    // Keep the original high-resolution source for the existing zoom and media model.
    image.src = src;
  }
  const api={enabled,resized,apply,sizes,held};
  if(typeof module !== 'undefined' && module.exports) module.exports=api;
  if(typeof window !== 'undefined') window.HHPdpGalleryImages=api;
})();

